import MUICollapse from "@mui/material/Collapse";

const Collapse = MUICollapse;

export default Collapse;
